import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

export const getPasscodes = async () => {
  const snap = await getDocs(collection(db, 'bride_passcodes'));
  return snap.docs.map(d => d.data().passcode).filter(Boolean);
};
